import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export type SurveyCompletedFormState = {
    availableLoad: string
    hasSpareLoad: { id: string; title: string } | null
    spareLoadKwh: string
    hasCanopy: { id: string; title: string } | null
    post_remarks: string
    surveyReportUrl: string | null
}

const SURVEY_COMPLETED_FORM_INITIAL: SurveyCompletedFormState = {
    availableLoad: "",
    hasSpareLoad: null,
    spareLoadKwh: "",
    hasCanopy: null,
    post_remarks: "",
    surveyReportUrl: null,
}

const initialState = {
    users: [],
    loading: false,
    totalPages: 1,
    page: 1,
    selectedValue: 10,
    chargerDisplayValues: [],
    chargerCurrentRules: [],
    sitesDisplayValues: [],
    sitesCurrentRules: [],
    StateDisplayValues: [],
    StateCurrentRules: [],
    CityDisplayValues: [],
    CityCurrentRules: [],
    currentRules: [],
    displayValues: [],
    SurveyFormValue: {
        cityId: [],
        stateId: [],
        chargerIds: [],
        powerRatingIds: [],
        statusId: [],
        siteIds: [] as number[],
        age_op: "",
        tags: [],
        category_ids: [] as any[],
        age: [],
        more_than_age: "",
        between_age1: "",
        between_age2: "",
        less_than_age: "",
        assigned_to: {
            id: "",
        },
        TicketStartDate: "",
        TicketEndDate: "",
        PlannedStartDate: "",
        PlannedEndDate: "",
        ETDStartDate: "",
        ETDEndDate: "",
        ClosureStartDate: "",
        ClosureEndDate: "",
        TaxationStartDate: "",
        TaxationEndDate: "",
        search_key: "",
        dealType: "",
        sow: "",
        ReadUnread: "all",
        ticketType: "all",
        vendor_ids: [],
        blocked_reason_id: [],
        parent_status: "all_tab",
        no_of_spots: "",
        added_on: null as any,
        added_from: "",
        added_to: "",
        country_id: null as any,
        zone_ids: [] as string[],
        region_ids: [] as string[],
        on_hold: null as any,
        on_hold_date: "",
        on_hold_reason_ids: [] as number[],
        progress_from: "",
        progress_to: "",
        progress_op: null as any,
        account_ids: [] as number[],
        ops_estimate_approval: "",
        sales_estimate_approval: "",
        ops_feasibility_status: "",
        dfc_approval_status: [] as any[],
        contractor_assigned: "all",
    },
    isNavigated: false,
    redirectedSiteId: null as { id: number; name: string } | null,
    SurveyDealTab: 0,
    selectedTab: 0,
    selectedMetric: null as string[] | null,
    surveyCompletedForm: SURVEY_COMPLETED_FORM_INITIAL as SurveyCompletedFormState,
    vendorDisplayValues: [],
    vendorCurrentRules: [],
    visibleColumns: [
        { name: "Ticket Type", visible: false },
        { name: "Address", visible: false },
        { name: "TAT", visible: false },
    ],
}

const SurveySlice = createSlice({
    name: "Survey",
    initialState,
    reducers: {
        setSurveyForm: (state, action) => {
            state.SurveyFormValue = action?.payload
        },
        setDisplayValues: (state, action) => {
            state.displayValues = action?.payload
        },
        setCurrentRuleValue: (state, action) => {
            state.currentRules = action?.payload
        },
        setVendorDisplayValues: (state, action) => {
            state.vendorDisplayValues = action?.payload
        },
        setVendorCurrentRuleValue: (state, action) => {
            state.vendorCurrentRules = action?.payload
        },
        setChargerDisplayValues: (state, action) => {
            state.chargerDisplayValues = action?.payload
        },
        setChargerCurrentRuleValue: (state, action) => {
            state.chargerCurrentRules = action?.payload
        },
        setSitesDisplayValues: (state, action) => {
            state.sitesDisplayValues = action?.payload
        },
        setSitesCurrentRuleValue: (state, action) => {
            state.sitesCurrentRules = action?.payload
        },
        setCityDisplayValues: (state, action) => {
            state.CityDisplayValues = action?.payload
        },
        setCityCurrentRuleValue: (state, action) => {
            state.CityCurrentRules = action?.payload
        },
        setStateDisplayValues: (state, action) => {
            state.StateDisplayValues = action?.payload
        },
        setStateCurrentRuleValue: (state, action) => {
            state.StateCurrentRules = action?.payload
        },
        setPages: (state, action) => {
            state.page = action?.payload
        },
        setSelectedValues: (state, action) => {
            state.selectedValue = action?.payload
        },
        setDealTab: (state, action) => {
            state.SurveyDealTab = action?.payload
        },
        setSelectedTab: (state, action) => {
            state.selectedTab = action?.payload
        },
        setIsNavigated: (state, action) => {
            state.isNavigated = action.payload
        },
        setSurveyRedirectedSiteId: (state, action) => {
            state.redirectedSiteId = action.payload
        },
        setVisibleColumns: (state, action) => {
            state.visibleColumns = action?.payload
        },
        setSelectedMetric: (state, action) => {
            state.selectedMetric = action?.payload
        },
        setSurveyCompletedForm: (state, action) => {
            state.surveyCompletedForm = action.payload
        },
        resetSurveyCompletedForm: state => {
            state.surveyCompletedForm = SURVEY_COMPLETED_FORM_INITIAL
        },
        setSurveyListParentStatus: (state, action: PayloadAction<string>) => {
            state.SurveyFormValue.parent_status = action.payload
        },
        setSurveyFormSiteIds: (state, action: PayloadAction<number[]>) => {
            state.SurveyFormValue.siteIds = action.payload
        },
    },
})

export const {
    setSurveyCompletedForm,
    resetSurveyCompletedForm,
    setVendorCurrentRuleValue,
    setVendorDisplayValues,
    setDisplayValues,
    setChargerCurrentRuleValue,
    setChargerDisplayValues,
    setCurrentRuleValue,
    setSurveyForm,
    setCityCurrentRuleValue,
    setCityDisplayValues,
    setStateCurrentRuleValue,
    setStateDisplayValues,
    setSitesCurrentRuleValue,
    setSitesDisplayValues,
    setPages,
    setSelectedValues,
    setSelectedTab,
    setDealTab,
    setIsNavigated,
    setVisibleColumns,
    setSelectedMetric,
    setSurveyRedirectedSiteId,
    setSurveyListParentStatus,
    setSurveyFormSiteIds,
} = SurveySlice.actions

export const getAllUser = (state: any) => state.users.loading

export default SurveySlice.reducer
